import _objectSpread from "/home/eletter/.jenkins/workspace/eletter_release/h5/platform/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import HeadCom from "../../headCom";
import InnerPdf from "@/components/inner-pdf/index.vue";
export default {
  name: 'protocolReview',
  components: {
    HeadCom: HeadCom,
    InnerPdf: InnerPdf
  },
  data: function data() {
    return {
      // 查询条件
      searchValue: {
        orderNo: "",
        bhNo: "",
        status: "0",
        warranteeCreditCode: "",
        warranteeName: "",
        page: 1,
        size: 10
      },
      totalCount: 0,
      // 审核状态
      statusOptions: [{
        label: "全部",
        value: ""
      }, {
        label: "待审核",
        value: "0"
      }, {
        label: "审核通过",
        value: "1"
      }, {
        label: "审核拒绝",
        value: "2"
      }, {
        label: "审核失败",
        value: "3"
      }],
      openAutoCheck: -1,
      //  1 开启自动审核   0:关闭自动审核
      title: '协议审核',
      //标题
      // 表单字段
      tableDateDec: [{
        prop: "orderNo",
        value: "订单编号",
        tooltip: true
      }, {
        prop: "bhNo",
        value: "保函编号",
        tooltip: true
      }, {
        prop: "warranteeName",
        value: "企业名称",
        tooltip: true
      }, {
        prop: "warranteeCreditCode",
        value: "企业信用代码",
        tooltip: true
      }, {
        prop: "createTime",
        value: "创建时间"
      }, {
        prop: "status",
        value: "审核状态",
        width: "100"
      }],
      tableData: [],
      // 表格数据
      innerPdfShow: false,
      //控制pdf签署弹框显示
      loading: true,
      //loading加载
      pdfBlobUrl: "",
      //签署文件的blob对象地址
      selectGuarantee: {},
      //当前签署的担保函数据
      isCloseBtn: true,
      //文件弹框关闭按钮
      isRejectBtn: true,
      //文件弹框驳回按钮
      isSubmitBtn: true,
      //文件弹框提交按钮
      isPassFlag: null,
      //签署通过标识，用于签署通过关闭更新操作
      dialogTitle: '审核'
    };
  },
  created: function created() {
    this.getProtocolList();
    this.findAutoStatus();
  },
  computed: {
    pdfDlalogEvent: function pdfDlalogEvent() {
      return {
        'success': this.signSuccess,
        'close': this.closeHandle
      };
    },
    pdfDlalogBind: function pdfDlalogBind() {
      return {
        isCloseBtn: this.isCloseBtn,
        isRejectBtn: this.isRejectBtn,
        isSubmitBtn: this.isSubmitBtn,
        pdfBlobUrl: this.pdfBlobUrl,
        'element-loading-text': '加载中',
        'element-loading-spinner': 'el-icon-loading',
        'element-loading-background': 'rgba(0, 0, 0, 0.6)',
        signText: '通过',
        title: this.dialogTitle
      };
    }
  },
  watch: {
    // 切换区域时刷新列表数据
    area: function area(a, b) {
      if (a != null) {
        this.getProtocolList();
      }
    }
  },
  methods: {
    getStatusName: function getStatusName(val) {
      switch (val) {
        case "0":
          return '待审核';

        case "1":
          return "审核通过";

        case "2":
          return "审核拒绝";

        case "3":
          return "审核失败";

        default:
          return val;
      }
    },
    // 查询审核开关状态
    findAutoStatus: function findAutoStatus() {
      var _this = this;

      if (this.userInfo.sonFlag != '0') return;
      this.requestAPI.findAutoCheckStatus({
        enterpriseId: this.userInfo.enterpriseId,
        type: 2
      }).then(function (res) {
        _this.openAutoCheck = Number(res.data);
      });
    },
    // 自动审核
    autoChange: function autoChange() {
      var _this2 = this;

      //1开启自动审核   0：关闭自动审核
      this.requestAPI.autoCheckSwitch({
        autoCheck: this.openAutoCheck,
        enterpriseId: this.userInfo.enterpriseId,
        type: 2
      }).then(function (res) {}).catch(function (err) {
        _this2.openAutoCheck = _this2.openAutoCheck === 1 ? 0 : 1;
      });
    },
    getProtocolList: function getProtocolList() {
      var _this3 = this;

      var obj = _objectSpread({}, this.searchValue);

      obj.guaranteeId = this.userInfo.enterpriseId; //担保机构id

      this.requestAPI.getBankGuaranteeContract(obj).then(function (res) {
        if (res.errorCode == '0000') {
          _this3.tableData = res.data && res.data.content || [];
          _this3.totalCount = res.data && res.data.totalCount || 0;
        }
      });
    },
    handleChange: function handleChange() {
      this.getProtocolList();
    },
    // 查询
    searchBtn: function searchBtn() {
      this.searchValue.page = 1;
      this.getProtocolList();
    },
    // 重置
    reset: function reset() {
      for (var key in this.searchValue) {
        if (key === 'page') {
          this.$set(this.searchValue, key, 1);
        } else if (key === 'size') {
          this.$set(this.searchValue, key, 10);
        } else if (key === 'status') {
          this.$set(this.searchValue, key, '0');
        } else {
          this.$set(this.searchValue, key, '');
        }
      }

      this.searchBtn();
    },
    // 审核和重新提交
    sureSign: function sureSign(row) {
      this.isCloseBtn = Boolean(row.signContractUrl) || row.status !== '0';
      this.isRejectBtn = !this.isCloseBtn;
      this.isSubmitBtn = !this.isCloseBtn;
      this.dialogTitle = this.isCloseBtn ? '查看' : '审核';
      this.selectGuarantee = row; //备份选择的数据，用于下面更新文件

      this.innerPdfShow = true;
      this.loadPdfFile(row);
    },
    // 加载文件(考虑到复用，单独抽离)
    loadPdfFile: function loadPdfFile(row) {
      var _this4 = this;

      this.loading = true; // 如果已经加载过则从备份地址拿

      if (row.copyFileUrl) {
        this.pdfBlobUrl = row.copyFileUrl;
        this.loading = false;
      } else {
        // signContractUrl为签署成功后的文件地址(用于更新)
        var data = {
          fileUrl: row.signContractUrl || row.contractFileUrl
        };
        this.publicMethed.downLoadImageC(data, function (res) {
          _this4.pdfBlobUrl = res; //获取的blob地址

          row.copyFileUrl = res; //备份一份地址用于二次加载不请求接口

          _this4.loading = false;
        }, function () {
          _this4.loading = false;
        });
      }
    },
    // 确认签署完成
    signSuccess: function signSuccess(type) {
      var _this5 = this;

      this.loading = true;
      var obj = {
        orderNo: this.selectGuarantee.orderNo,
        status: type
      };
      this.requestAPI.auditBankGuaranteeContract(obj).then(function (res) {
        if (res.errorCode == '0000') {
          _this5.$message.success("操作成功"); // "1"表示通过，"2"表示驳回


          if (type == '2') {
            // 驳回直接关闭弹框，无需更新文件
            _this5.loading = false;
            _this5.innerPdfShow = false;

            _this5.getProtocolList();
          } else {
            _this5.$set(_this5.selectGuarantee, "signContractUrl", res.data.hadoopFileUrl);

            _this5.selectGuarantee.copyFileUrl = null; //移除原备份地址，使新文件重新获取

            _this5.loadPdfFile(_this5.selectGuarantee); //签署后更新文件


            _this5.isPassFlag = true; // 更新按钮显示状态

            _this5.isCloseBtn = true;
            _this5.isRejectBtn = false;
            _this5.isSubmitBtn = false;
          }
        }
      }).catch(function (err) {
        _this5.loading = false;
      });
    },
    // 关闭弹框时事件(不包含关闭弹框，关闭操作已写在行内)
    closeHandle: function closeHandle() {
      if (this.isPassFlag) {
        this.isPassFlag = false;
        this.getProtocolList();
      }
    }
  }
};